export default __webpack_public_path__ + "static/media/I-become-a-mother-EN.c3cdc6ec.png";